import { createContext, Dispatch, SetStateAction } from "react";

/**
 * The active view's title, surfaced in the global TopHeader.
 *
 * Split into separate value + setter contexts on purpose: a view *sets* the
 * title (via the setter context) while only TopHeader *reads* it (via the
 * value context). Because the setter identity is stable, setting the title
 * never re-renders the view/table subtree — only the value consumer
 * (TopHeader) re-renders when the title actually changes. See
 * hooks/use_view_title.ts.
 */
export const ViewTitleValueContext = createContext<string | null>(null);

export const ViewTitleSetterContext = createContext<
  Dispatch<SetStateAction<string | null>>
>(() => {});
